import { ClientTrackableEvents } from 'common/events/ClientEvents';
import { createTaggedLogger } from 'logging/createTaggedLogger';
import { ITracker } from './ITracker';

const logger = createTaggedLogger('mock-tracker');

export class MockTracker implements ITracker {
  // eslint-disable-next-line class-methods-use-this -- disabled because this is a mock tracker
  public track<K extends keyof ClientTrackableEvents>(eventName: K, data: ClientTrackableEvents[K]): void {
    logger.info('tracking', { eventName, data });
  }
}
